'use client';
import { createStyles, getSize, rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var sizes = {
    xs1: rem(1)
};
var getStrokeStyles = function(param) {
    var length = param.length, spacing = param.spacing, color = param.color, orientation = param.orientation, width = param.width;
    var isHorizontal = orientation === "horizontal";
    var _obj;
    return _obj = {}, _obj[isHorizontal ? "height" : "width"] = width, _obj[isHorizontal ? "width" : "height"] = "100%", _obj.backgroundPosition = isHorizontal ? "bottom" : "right", _obj.backgroundRepeat = isHorizontal ? "repeat-x" : "repeat-y", _obj.background = "repeating-linear-gradient(" + (isHorizontal ? "to right, " : "to bottom, ") + color + " 0 " + length + "px, transparent " + length + "px " + (length + spacing) + "px)", _obj;
};
var getDottedStyles = function(options) {
    return {
        horizontal: getStrokeStyles(_extends({}, options, {
            orientation: "horizontal",
            length: 1,
            spacing: 6
        })),
        vertical: getStrokeStyles(_extends({}, options, {
            orientation: "vertical",
            length: 1,
            spacing: 6
        }))
    };
};
var getDashedStyles = function(options) {
    return {
        horizontal: getStrokeStyles(_extends({}, options, {
            orientation: "horizontal",
            length: 4,
            spacing: 8
        })),
        vertical: getStrokeStyles(_extends({}, options, {
            orientation: "vertical",
            length: 4,
            spacing: 8
        }))
    };
};
var getSolidStyles = function(param) {
    var width = param.width, color = param.color;
    return {
        horizontal: {
            width: "100%",
            border: 0,
            borderTopWidth: width,
            borderTopColor: color,
            borderTopStyle: "solid",
            margin: 0
        },
        vertical: {
            height: "100%",
            border: 0,
            alignSelf: "center",
            borderLeftWidth: width,
            borderLeftColor: color,
            borderLeftStyle: "solid"
        }
    };
};
var strategies = {
    solid: getSolidStyles,
    dotted: getDottedStyles,
    dashed: getDashedStyles
};
var getVariantStyles = function(options, variant, hatch) {
    if (hatch) {
        var length = hatch.length, spacing = hatch.spacing;
        return {
            horizontal: getStrokeStyles(_extends({}, options, {
                orientation: "horizontal",
                length: length,
                spacing: spacing
            })),
            vertical: getStrokeStyles(_extends({}, options, {
                orientation: "vertical",
                length: length,
                spacing: spacing
            }))
        };
    }
    var strategy = strategies[variant];
    return strategy ? strategy(options) : getSolidStyles(options);
};
var useStyles = createStyles(function(theme, param, param1) {
    var color = param.color, hatch = param.hatch, withLabel = param.withLabel, length = param.length;
    var size = param1.size, variant = param1.variant;
    var _theme_fn = theme.fn, themeColor = _theme_fn.themeColor, primaryShade = _theme_fn.primaryShade;
    var shade = primaryShade(themeColor(color, theme.palette.border.divider));
    var width = getSize({
        size: size,
        sizes: sizes
    });
    var spacing = theme.fn.space(size);
    var computedLength = theme.fn.space(length);
    var _getVariantStyles = getVariantStyles({
        width: rem(width),
        color: shade
    }, variant, hatch), vertical = _getVariantStyles.vertical, horizontal = _getVariantStyles.horizontal;
    return {
        root: _extends({
            "&[data-horizontal=true]": _extends({}, horizontal, length && {
                width: computedLength
            }),
            "&[data-vertical=true]": _extends({}, vertical, !length && {
                alignSelf: "stretch"
            }, {
                height: length ? computedLength : "auto"
            })
        }, withLabel && {
            display: "flex",
            whiteSpace: "nowrap",
            textAlign: "center",
            alignItems: "center",
            border: 0,
            "&::before, &::after": {
                content: '""',
                alignSelf: "center"
            },
            "&[data-horizontal=true]": _extends({
                "&::before, &::after": _extends({
                    width: "100%"
                }, horizontal)
            }, length && {
                width: computedLength
            }),
            "&[data-align=start][data-horizontal=true]": {
                "&::before": {
                    width: "0%"
                },
                "&::after": {
                    width: "100%"
                }
            },
            "&[data-align=end][data-horizontal=true]": {
                "&::before": {
                    width: "100%"
                },
                "&::after": {
                    width: "0%"
                }
            },
            "&[data-vertical=true]": {
                flexDirection: "column",
                alignSelf: "stretch",
                height: length ? computedLength : "auto",
                "&::before, &::after": _extends({
                    height: "100%"
                }, vertical)
            }
        }),
        label: _extends({
            display: "inline-block",
            color: shade
        }, withLabel && {
            "&[data-align=start][data-horizontal=true]": {
                paddingRight: spacing
            },
            "&[data-align=end][data-horizontal=true]": {
                paddingLeft: spacing
            },
            "&[data-align=center][data-horizontal=true]": {
                paddingRight: spacing,
                paddingLeft: spacing
            },
            "&[data-vertical=true]": {
                paddingTop: spacing,
                paddingBottom: spacing
            }
        })
    };
});

export { useStyles as default };
